<!-- ASSIGNEES -->
<pp-point-assignees
  [ppSelectedAssignees]="ppAssignees"
  (ppOnChange)="updateAssignees($event)"
  [ppWorkspaceId]="ppWorkspaceId"
  [ppDisabled]="!ppCanEdit"
  data-test="pointAssignees"
></pp-point-assignees>

@if (workspaces) {
  <pp-point-fields-tags
    [ppPointId]="ppPointId"
    [ppTags]="ppTags"
    [ppWorkspaceId]="ppWorkspaceId"
    [ppNew]="ppNew"
    data-test="pointFieldsTags"
  />
  @switch (fieldsDisplay) {
    @case ('flat') {
      @for (fieldId of readableCustomFields; track fieldId) {
        <ng-container *ngTemplateOutlet="customField; context: { $implicit: fieldId }" />
      }
    }
    @case ('grouped') {
      @for (entry of layoutEntries; track entry.id) {
        @if (entry.type === 'GROUP') {
          <pp-accordion class="pointFields__group" [ppTitle]="entry.title">
            @for (fieldId of entry.fieldIds; track fieldId) {
              <ng-container *ngTemplateOutlet="customField; context: { $implicit: fieldId }" />
            }
          </pp-accordion>
        } @else {
          <ng-container *ngTemplateOutlet="customField; context: { $implicit: entry.id }" />
        }
      }
    }
  }
}

<ng-template #customField let-fieldId>
  @if (pointCustomFields?.[fieldId]) {
    <div>
      @switch (customFields[ppWorkspaceId][fieldId].type) {
        @case (ECustomFieldType.TEXT) {
          <pp-point-fields-text
            data-test="pointFieldText"
            [ppFieldId]="customFields[ppWorkspaceId][fieldId]?.id"
            [ppFieldLabel]="customFields[ppWorkspaceId][fieldId]?.label"
            [ppFieldDescription]="customFields[ppWorkspaceId][fieldId]?.description"
            [ppWorkspaceId]="ppWorkspaceId"
            [ppPointId]="ppPointId"
            [ppNew]="ppNew"
            [ppCanEdit]="editableCustomFields.includes(fieldId) || allFieldsEditable"
            [ppIsLocked]="customFields[ppWorkspaceId][fieldId]?.lockedValue"
          />
        }
        @case (ECustomFieldType.DATE) {
          <pp-point-fields-date
            data-test="pointFieldDate"
            [ppFieldId]="customFields[ppWorkspaceId][fieldId]?.id"
            [ppFieldLabel]="customFields[ppWorkspaceId][fieldId]?.label"
            [ppFieldDescription]="customFields[ppWorkspaceId][fieldId]?.description"
            [ppFieldValue]="pointCustomFields[fieldId]?.value"
            [ppWorkspaceId]="ppWorkspaceId"
            [ppPointId]="ppPointId"
            [ppNew]="ppNew"
            [ppCanEdit]="editableCustomFields.includes(fieldId) || allFieldsEditable"
            [ppIsLocked]="customFields[ppWorkspaceId][fieldId]?.lockedValue"
          />
        }
        @case (ECustomFieldType.LIST) {
          <pp-point-fields-list
            data-test="pointFieldList"
            [ppField]="customFields[ppWorkspaceId][fieldId]"
            [ppFieldId]="fieldId"
            [ppFieldLabel]="customFields[ppWorkspaceId][fieldId]?.label"
            [ppFieldValue]="pointCustomFields[fieldId]?.value"
            [ppFieldValueId]="pointCustomFields[fieldId]?.idOfChosenElement?.toString()"
            [ppFieldDescription]="customFields[ppWorkspaceId][fieldId]?.description"
            [ppWorkspaceId]="ppWorkspaceId"
            [ppPointId]="ppPointId"
            [ppNew]="ppNew"
            [ppCanEdit]="editableCustomFields.includes(fieldId) || allFieldsEditable"
            [ppVolyActive]="customFields[ppWorkspaceId][fieldId]?.volyIntegrationActive"
            [ppIsLocked]="
              handleVolyIntegrationLockedValue(
                customFields[ppWorkspaceId][fieldId]?.volyIntegrationActive,
                customFields[ppWorkspaceId][fieldId]?.lockedValue
              )
            "
          />
        }
        @case (ECustomFieldType.MULTI_LIST) {
          <pp-point-fields-multi-list
            data-test="pointFieldMultiList"
            [ppField]="customFields[ppWorkspaceId][fieldId]"
            [ppFieldId]="fieldId"
            [ppFieldLabel]="customFields[ppWorkspaceId][fieldId]?.label"
            [ppFieldValue]="pointCustomFields[fieldId]?.value"
            [ppFieldValueIds]="pointCustomFields[fieldId]?.selectedItemIds"
            [ppFieldDescription]="customFields[ppWorkspaceId][fieldId]?.description"
            [ppWorkspaceId]="ppWorkspaceId"
            [ppPointId]="ppPointId"
            [ppNew]="ppNew"
            [ppCanEdit]="editableCustomFields.includes(fieldId) || allFieldsEditable"
            [ppVolyActive]="customFields[ppWorkspaceId][fieldId]?.volyIntegrationActive"
            [ppIsLocked]="
              handleVolyIntegrationLockedValue(
                customFields[ppWorkspaceId][fieldId]?.volyIntegrationActive,
                customFields[ppWorkspaceId][fieldId]?.lockedValue
              )
            "
          />
        }
        @case (ECustomFieldType.COST) {
          <pp-point-fields-cost
            data-test="pointFieldCost"
            [ppFieldId]="customFields[ppWorkspaceId][fieldId]?.id"
            [ppFieldLabel]="customFields[ppWorkspaceId][fieldId]?.label"
            [ppFieldCurrencySymbol]="customFields[ppWorkspaceId][fieldId]?.currencySymbol"
            [ppFieldCurrencyCode]="customFields[ppWorkspaceId][fieldId]?.currencyCode"
            [ppFieldDescription]="customFields[ppWorkspaceId][fieldId]?.description"
            [ppVolyActive]="customFields[ppWorkspaceId][fieldId]?.volyIntegrationActive"
            [ppPointCustomField]="pointCustomFields[fieldId]"
            [ppWorkspaceId]="ppWorkspaceId"
            [ppPointId]="ppPointId"
            [ppNew]="ppNew"
            [ppCanEdit]="editableCustomFields.includes(fieldId) || allFieldsEditable"
            [ppSubfieldsActive]="customFields[ppWorkspaceId][fieldId]?.subValuesActive"
            [ppIsLocked]="
              handleVolyIntegrationLockedValue(
                customFields[ppWorkspaceId][fieldId]?.volyIntegrationActive,
                customFields[ppWorkspaceId][fieldId]?.lockedValue
              )
            "
          />
        }
        @case (ECustomFieldType.PERCENTAGE) {
          <pp-point-fields-percentage
            data-test="pointFieldPercentage"
            [ppFieldId]="customFields[ppWorkspaceId][fieldId]?.id"
            [ppFieldLabel]="customFields[ppWorkspaceId][fieldId]?.label"
            [ppField]="pointCustomFields[fieldId]"
            [ppFieldDescription]="customFields[ppWorkspaceId][fieldId]?.description"
            [ppWorkspaceId]="ppWorkspaceId"
            [ppPointId]="ppPointId"
            [ppNew]="ppNew"
            [ppCanEdit]="editableCustomFields.includes(fieldId) || allFieldsEditable"
            [ppSubfieldsActive]="customFields[ppWorkspaceId][fieldId]?.subValuesActive"
            [ppIsLocked]="customFields[ppWorkspaceId][fieldId]?.lockedValue"
          />
        }
        @case (ECustomFieldType.FORMULA) {
          <pp-point-fields-formula
            data-test="pointFieldFormula"
            [ppFieldId]="customFields[ppWorkspaceId][fieldId]?.id"
            [ppFieldLabel]="customFields[ppWorkspaceId][fieldId]?.label"
            [ppFieldDescription]="customFields[ppWorkspaceId][fieldId]?.description"
            [ppField]="pointCustomFields[fieldId]"
            [ppWorkspaceId]="ppWorkspaceId"
            [ppFieldCurrencySymbol]="customFields[ppWorkspaceId][fieldId]?.currencySymbol"
            [ppFieldCurrencyCode]="customFields[ppWorkspaceId][fieldId]?.currencyCode"
            [ppNew]="ppNew"
          />
        }
        @case (ECustomFieldType.TIMELINE) {
          <pp-point-fields-timeline
            data-test="pointFieldTimeline"
            [ppFieldId]="customFields[ppWorkspaceId][fieldId]?.id"
            [ppFieldLabel]="customFields[ppWorkspaceId][fieldId]?.label"
            [ppFieldDescription]="customFields[ppWorkspaceId][fieldId]?.description"
            [ppField]="pointCustomFields[fieldId]"
            [ppWorkspaceId]="ppWorkspaceId"
            [ppPointId]="ppPointId"
            [ppNew]="ppNew"
            [ppCanEdit]="editableCustomFields.includes(fieldId) || allFieldsEditable"
            [ppIsLocked]="customFields[ppWorkspaceId][fieldId]?.lockedValue"
          />
        }
        @case (ECustomFieldType.TIME) {
          <pp-point-fields-time
            data-test="pointFieldTime"
            [ppFieldId]="customFields[ppWorkspaceId][fieldId]?.id"
            [ppFieldLabel]="customFields[ppWorkspaceId][fieldId]?.label"
            [ppFieldDescription]="customFields[ppWorkspaceId][fieldId]?.description"
            [ppField]="pointCustomFields[fieldId]"
            [ppWorkspaceId]="ppWorkspaceId"
            [ppPointId]="ppPointId"
            [ppNew]="ppNew"
            [ppCanEdit]="editableCustomFields.includes(fieldId) || allFieldsEditable"
            [ppIsLocked]="customFields[ppWorkspaceId][fieldId]?.lockedValue"
          />
        }
        @case (ECustomFieldType.NUMBERS) {
          <pp-point-fields-numbers
            data-test="pointFieldNumbers"
            [ppFieldId]="customFields[ppWorkspaceId][fieldId]?.id"
            [ppFieldLabel]="customFields[ppWorkspaceId][fieldId]?.label"
            [ppFieldDescription]="customFields[ppWorkspaceId][fieldId]?.description"
            [ppField]="pointCustomFields[fieldId]"
            [ppWorkspaceId]="ppWorkspaceId"
            [ppPointId]="ppPointId"
            [ppNew]="ppNew"
            [ppCanEdit]="editableCustomFields.includes(fieldId) || allFieldsEditable"
            [ppSubfieldsActive]="customFields[ppWorkspaceId][fieldId]?.subValuesActive"
            [ppIsLocked]="customFields[ppWorkspaceId][fieldId]?.lockedValue"
          />
        }
        @case (ECustomFieldType.RICHTEXT) {
          <pp-point-fields-rich-text
            data-test="pointFieldRichtext"
            [ppFieldId]="customFields[ppWorkspaceId][fieldId]?.id"
            [ppFieldLabel]="customFields[ppWorkspaceId][fieldId]?.label"
            [ppFieldDescription]="customFields[ppWorkspaceId][fieldId]?.description"
            [ppRichText]="pointCustomFields[fieldId]?.value"
            [ppPlainText]="pointCustomFields[fieldId]?.plainText"
            [ppWorkspaceId]="ppWorkspaceId"
            [ppPointId]="ppPointId"
            [ppNew]="ppNew"
            [ppCanEdit]="editableCustomFields.includes(fieldId) || allFieldsEditable"
            [ppIsLocked]="customFields[ppWorkspaceId][fieldId]?.lockedValue"
          />
        }
        @case (ECustomFieldType.CHECKBOX) {
          <pp-point-fields-checkbox
            data-test="pointFieldCheckbox"
            [ppFieldId]="customFields[ppWorkspaceId][fieldId]?.id"
            [ppFieldLabel]="customFields[ppWorkspaceId][fieldId]?.label"
            [ppFieldDescription]="customFields[ppWorkspaceId][fieldId]?.description"
            [ppValue]="pointCustomFields[fieldId]?.value"
            [ppField]="pointCustomFields[fieldId]"
            [ppWorkspaceId]="ppWorkspaceId"
            [ppPointId]="ppPointId"
            [ppNew]="ppNew"
            [ppCanEdit]="editableCustomFields.includes(fieldId) || allFieldsEditable"
            [ppIsLocked]="customFields[ppWorkspaceId][fieldId]?.lockedValue"
          />
        }
      }
    </div>
  }
</ng-template>
